/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';
import PropTypes from 'prop-types';
import { Clock } from '../../Clock';
import { ClockTypes } from '../../Clock/ClockTypes';
import { ImageLoader } from '../../ImageLoader';
import { ImageLoaderTypes } from '../../ImageLoader/ImageLoaderTypes';
import { SettingsHeaderProps } from './SettingsHeaderProps';
import { ServicesClientImpl } from '../../../core/impls/ServicesClientImpl';
import {
    PRIMARY_BRANDING_LOGO_HEIGHT_1080P,
    PRIMARY_BRANDING_LOGO_WIDTH_1080P,
} from '../../../config';
import { Settings } from '../../../core/device/Settings';

import './SettingsHeader.scss';

const SettingsHeader: FunctionComponent<SettingsHeaderProps> = ({ title }): JSX.Element => {
    const services = new ServicesClientImpl();
    const primaryBrandingImageUrl = services.getPartnerBrandingImageUrl(
        PRIMARY_BRANDING_LOGO_WIDTH_1080P,
        PRIMARY_BRANDING_LOGO_HEIGHT_1080P,
    );
    const settingsService = new Settings();
    const isVideoWindowEnabled = settingsService.isVideoWindowEnabled();

    return (
        <div className={`settings-header-container ${isVideoWindowEnabled ? 'adjust-width' : ''}`}>
            <div className="settings-header-content">
                <ImageLoader
                    src={primaryBrandingImageUrl}
                    imageType={ImageLoaderTypes.SETTINGS_SCREEN_CHANNEL_BRANDING}
                    dataTestId="settings-primary-branding"
                />
                <div className="divider" />
                <div className="settings-header-title">{title}</div>
            </div>
            <Clock
                type={`${
                    !isVideoWindowEnabled
                        ? ClockTypes.SETTINGS_HEADER_CLOCK
                        : ClockTypes.SETTINGS_HEADER_CLOCK_WITH_VIDEO_WINDOW
                } `}
            />
        </div>
    );
};

SettingsHeader.propTypes = {
    title: PropTypes.string.isRequired,
};

export default SettingsHeader;
